import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {
  CommoditiesAddPage,
  CommoditiesEditPage,
  CommoditiesPage,
  // ImpactStoriesPage,
  LandscapeAboutContactPersonAddPage,
  LandscapeAboutContactPersonEditPage,
  LandscapeAboutContactPersonsPage,
  LandscapeAboutLandscapeAddPage,
  LandscapeAboutLandscapeEditPage,
  LandscapeAboutLandscapePage,
  LandscapeAboutParticipantAddPage,
  LandscapeAboutParticipantEditPage,
  LandscapeAboutParticipantPage,
  LandscapeAddStoryPage,
  LandscapeBasicInformationAddPage,
  LandscapeBasicInformationEditPage,
  LandscapeCommoditiesPage,
  LandscapeDocumentsPage,
  ReportingDetailsCollectionsAddPage,
  ReportingDetailsCollectionsEditPage,
  ReportingDetailsCollectionsPage,
  ReportingDetailsGoalsAddPage,
  ReportingDetailsGoalsEditPage,
  ReportingDetailsGoalsPage,
  ReportingDetailsIndicatorsAddPage,
  ReportingDetailsIndicatorsEditPage,
  ReportingDetailsIndicatorsPage,
  ReportingDetailsThemesAddPage,
  ReportingDetailsThemesEditPage,
  ReportingDetailsThemesPage,
  ReportingDetailsVerificationStatusesAddPage,
  ReportingDetailsVerificationStatusesEditPage,
  ReportingDetailsVerificationStatusesPage,
  UserManagementEventLoggingPage,
  UserManagementUsersEditDetailsPage,
  UserManagementUsersEditRolesPage,
  UserManagementUsersPage,
  LandscapeAboutNotSavedInfoPage,
  LandscapeNotSavedInfoPage,
  LandscapeProjectsEditPage,
  // UserManagementReportsNewsletterPage,
  // UserManagementReportsContactPage,
  LandscapeProjectsEditAddProjectsPage,
  LandscapeProjectsAddProjectsRequestedSupportPage,
  LandscapeProjectsAddProjectsDocumentsPage,
  LandscapeProjectsAddProjectsContactInformationPage,
  NotAuthorizedPage,
  LandingPage,
  LandscapeCommoditiesEditPage,
  LandscapesPage,
  LandscapeCommoditiesAddPage,
  LandscapeProjectsAddProjectsGeneralInformationLeadPartnersPage,
  LandscapeProjectsAddProjectsGeneralInformationImageGalleryPage,
  LandscapeProjectsAddProjectsSupportersPage,
  LandscapeProjectsAddProjectsImpactPage,
  LandscapeProjectsAddProjectsImpactCommodityPage,
  LandscapeProjectsAddProjectsImpactIndicatorsPage,
  // ImpactStoriesAddPage,
  LandscapeUpdatesPage,
  LandscapeContentBlocksPage,
  LandscapeEditStoryPage,
  LandscapeImageBlockAddPage,
  LandscapeAddProjectsAddSupporterPage,
  LandscapeProjectsAddProjectsAddContactPersonPage,
  LandscapeIndicatorsPage,
  LandscapeProjectsAddProjectsEditContactPersonPage,
  LandscapeTextBlockAddPage,
  LandscapeImageBlockEditPage,
  LandscapeTextBlockEditPage,
  LandscapeAboutCommittedBuyersPage,
  LandscapeAboutCommittedBuyersAddPartnerPage,
  OrganizationsPage,
  OrganizationEditPage,
  OrganizationContentBlocksPage,
  OrganizationImageBlockAddPage,
  OrganizationTextBlockAddPage,
  OrganizationImageBlockEditPage,
  OrganizationTextBlockEditPage,
  OrganizationDocumentsPage,
  OrganizationCommoditiesPage,
  OrganizationLandscapesPage,
  OrganizationAddPage,
  LandscapeIndicatorVerificationApproachPage,
  LandscapeIndicatorContributionPage,
  LandscapeIndicatorContributionAddPage,
  LandscapeIndicatorContributionEditPage,
  LandscapeIndicatorBaselinePage,
  LandscapeIndicatorTargetPage,
  LandscapeIndicatorSupportingDocumentsPage,
  LandscapeIndicatorExternalResourcesPage,
  LandscapeIndicatorExternalResourceAddPage,
  LandscapeIndicatorExternalResourceEditPage,
  LandscapeIndicatorDescriptionPage,
  // LandscapeTypesPage,
  // LandscapeTypesAddPage,
  // LandscapeTypesEditPage,
} from '../components';
import Spinner from '../components/atoms/Spinner/Spinner';
import MainTemplate from '../templates/MainTemplate';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import ProtectedRoute from './ProtectedRoute';

const AppRouter: React.FC = () => (
  <Router>
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route
          path="*"
          element={
            <MsalAuthenticationTemplate
              interactionType={InteractionType.Redirect}
            >
              <MainTemplate>
                <Routes>
                  <Route
                    path={'/not-authorized'}
                    element={<NotAuthorizedPage />}
                  />
                  <Route path="/" element={<LandingPage />} />
                  <Route
                    path="/landscapes"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapesPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/add/basic-information"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeBasicInformationAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/basic-information"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeBasicInformationEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/about"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeAboutParticipantPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeProjectsEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/basic-information"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeProjectsEditAddProjectsPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/basic-information/requested-support"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeProjectsAddProjectsRequestedSupportPage />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/documents"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeProjectsAddProjectsDocumentsPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/contact-information"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeProjectsAddProjectsContactInformationPage />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/contact-information/add-contact-person"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeProjectsAddProjectsAddContactPersonPage />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/contact-information/edit-contact-person/:contactPersonId"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeProjectsAddProjectsEditContactPersonPage />
                        }
                      />
                    }
                  />

                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/supporters"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeProjectsAddProjectsSupportersPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/supporters/add-supporter/:relationType"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeAddProjectsAddSupporterPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/impact"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeProjectsAddProjectsImpactPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/impact/commodity"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeProjectsAddProjectsImpactCommodityPage />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/impact/indicators"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeProjectsAddProjectsImpactIndicatorsPage />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/general-information"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeProjectsAddProjectsGeneralInformationLeadPartnersPage />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/projects/add-project/:projectId/general-information/image-gallery"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeProjectsAddProjectsGeneralInformationImageGalleryPage />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/about/participant/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeAboutParticipantAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/about/committed-buyers"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeAboutCommittedBuyersPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/about/committed-buyers/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={
                          <LandscapeAboutCommittedBuyersAddPartnerPage />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/about/participant/edit/:participantId"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeAboutParticipantEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/about/landscape"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeAboutLandscapePage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/about/landscape/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeAboutLandscapeAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/about/landscape/edit/:galleryTileId"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeAboutLandscapeEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/about/contact-person/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeAboutContactPersonAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/about/contact-person/edit/:contactPersonId"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeAboutContactPersonEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/about/contact-person"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeAboutContactPersonsPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/commodities"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeCommoditiesPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/commodities/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeCommoditiesAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/commodities/edit/:commodityId"
                    element={<LandscapeCommoditiesEditPage />}
                  />
                  <Route
                    path="/landscapes/edit/:id/documents"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeDocumentsPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/updates"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'LandscapeInitiativeManager']}
                        element={<LandscapeUpdatesPage />}
                      />
                    }
                  />
                  {/* <Route
                    path="/landscapes/types"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeTypesPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/types/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeTypesAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/types/:id/edit"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeTypesEditPage />}
                      />
                    }
                  /> */}
                  <Route
                    path="/organizations"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'BuyerManager']}
                        element={<OrganizationsPage />}
                      />
                    }
                  />
                  <Route
                    path="/organizations/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'BuyerManager']}
                        element={<OrganizationAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/organizations/edit/:organizationId"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'BuyerManager']}
                        element={<OrganizationEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/organizations/edit/:organizationId/content-blocks"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'BuyerManager']}
                        element={<OrganizationContentBlocksPage />}
                      />
                    }
                  />
                  <Route
                    path="/organizations/edit/:organizationId/image-block/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'BuyerManager']}
                        element={<OrganizationImageBlockAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/organizations/edit/:organizationId/text-block/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'BuyerManager']}
                        element={<OrganizationTextBlockAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/organizations/edit/:organizationId/image-block/edit/:blockId"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'BuyerManager']}
                        element={<OrganizationImageBlockEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/organizations/edit/:organizationId/text-block/edit/:blockId"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'BuyerManager']}
                        element={<OrganizationTextBlockEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/organizations/edit/:organizationId/documents"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'BuyerManager']}
                        element={<OrganizationDocumentsPage />}
                      />
                    }
                  />
                  <Route
                    path="/organizations/edit/:organizationId/commodities"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'BuyerManager']}
                        element={<OrganizationCommoditiesPage />}
                      />
                    }
                  />
                  <Route
                    path="/organizations/edit/:organizationId/landscapes"
                    element={
                      <ProtectedRoute
                        roles={['Admin', 'BuyerManager']}
                        element={<OrganizationLandscapesPage />}
                      />
                    }
                  />
                  <Route
                    path="/commodities"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<CommoditiesPage />}
                      />
                    }
                  />
                  <Route
                    path="/commodities/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<CommoditiesAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/commodities/edit/:id"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<CommoditiesEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/goals"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsGoalsPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/goals/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsGoalsAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/goals/:id/edit"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsGoalsEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/verification-statuses"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsVerificationStatusesPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/verification-statuses/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <ReportingDetailsVerificationStatusesAddPage />
                        }
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/verification-statuses/:id/edit"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <ReportingDetailsVerificationStatusesEditPage />
                        }
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/indicators"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsIndicatorsPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/indicators/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsIndicatorsAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/indicators/:id/edit"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsIndicatorsEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/themes"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsThemesPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/themes/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsThemesAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/themes/:id/edit"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsThemesEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/collections"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsCollectionsPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/collections/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsCollectionsAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/reporting-details/collections/:id/edit"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ReportingDetailsCollectionsEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/user-management/eventLogging"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<UserManagementEventLoggingPage />}
                      />
                    }
                  />
                  <Route
                    path="/user-management/users"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<UserManagementUsersPage />}
                      />
                    }
                  />
                  <Route
                    path="/user-management/users/:id/edit/details"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<UserManagementUsersEditDetailsPage />}
                      />
                    }
                  />
                  <Route
                    path="/user-management/users/:id/edit/roles"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<UserManagementUsersEditRolesPage />}
                      />
                    }
                  />
                  {/* <Route
                    path="/impact-stories&platform-updates/impact-stories"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ImpactStoriesPage />}
                      />
                    }
                  /> */}
                  {/* <Route
                    path="/impact-stories&platform-updates/impact-stories/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<ImpactStoriesAddPage />}
                      />
                    }
                  /> */}
                  {/* <Route
                    path="/user-management/reports/newsletters"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<UserManagementReportsNewsletterPage />}
                      />
                    }
                  /> */}
                  {/* <Route
                    path="/user-management/reports/contacts"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<UserManagementReportsContactPage />}
                      />
                    }
                  /> */}
                  <Route
                    path="/landscapes/edit/:id/updates/story/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeAddStoryPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/updates/story/edit/:storyId/content-blocks"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeContentBlocksPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/updates/story/edit/:storyId/image-block/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeImageBlockAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/updates/story/edit/:storyId/text-block/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeTextBlockAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/updates/story/edit/:storyId/image-block/edit/:blockId"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeImageBlockEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/updates/story/edit/:storyId/text-block/edit/:blockId"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeTextBlockEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/updates/story/edit/:storyId"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeEditStoryPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/add/about"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeAboutNotSavedInfoPage content="The compact Basic Information must be saved before adding participants." />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/add/about/landscape"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeAboutNotSavedInfoPage content="The compact Basic Information must be saved before adding landscape information." />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/add/about/commited-buyers"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeAboutNotSavedInfoPage content="The compact Basic Information must be saved before adding committed buyers." />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/add/about/contact-person"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeAboutNotSavedInfoPage content="The compact Basic Information must be saved before adding contact persons." />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/add/indicators"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeNotSavedInfoPage content="The compact Basic Information must be saved before adding indicators." />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/indicators"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeIndicatorsPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/indicators/edit/:landscapeIndicatorId/description"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeIndicatorDescriptionPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/indicators/edit/:landscapeIndicatorId/verification-approach"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeIndicatorVerificationApproachPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/indicators/edit/:landscapeIndicatorId/external-resources"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeIndicatorExternalResourcesPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/indicators/edit/:landscapeIndicatorId/external-resources/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeIndicatorExternalResourceAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/indicators/edit/:landscapeIndicatorId/external-resources/edit/:externalResourceId"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeIndicatorExternalResourceEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/indicators/edit/:landscapeIndicatorId/contribution"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeIndicatorContributionPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/indicators/edit/:landscapeIndicatorId/contribution/add"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeIndicatorContributionAddPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/indicators/edit/:landscapeIndicatorId/contribution/edit/:contributionId"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeIndicatorContributionEditPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/indicators/edit/:landscapeIndicatorId/baseline"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeIndicatorBaselinePage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/indicators/edit/:landscapeIndicatorId/target"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeIndicatorTargetPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/edit/:id/indicators/edit/:landscapeIndicatorId/supporting-documents"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={<LandscapeIndicatorSupportingDocumentsPage />}
                      />
                    }
                  />
                  <Route
                    path="/landscapes/add/projects"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeNotSavedInfoPage content="The compact Basic Information must be saved before adding projects." />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/add/landscape-updates"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeNotSavedInfoPage content="The compact Basic Information must be saved before adding compact updates." />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/add/commodities"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeNotSavedInfoPage content="The compact Basic Information must be saved before adding commodities." />
                        }
                      />
                    }
                  />
                  <Route
                    path="/landscapes/add/documents"
                    element={
                      <ProtectedRoute
                        roles={['Admin']}
                        element={
                          <LandscapeNotSavedInfoPage content="The compact Basic Information must be saved before uploading documents." />
                        }
                      />
                    }
                  />
                </Routes>
              </MainTemplate>
            </MsalAuthenticationTemplate>
          }
        />
      </Routes>
    </Suspense>
  </Router>
);

export default AppRouter;
